import { render } from "./ClearanceDashboard.vue?vue&type=template&id=3e38b7f0&scoped=true"
import script from "./ClearanceDashboard.vue?vue&type=script&lang=js"
export * from "./ClearanceDashboard.vue?vue&type=script&lang=js"

import "./ClearanceDashboard.vue?vue&type=style&index=0&id=3e38b7f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e38b7f0"]])

export default __exports__